import React from "react";
import PropTypes from "prop-types";
import Clipboard from "react-clipboard.js";
import { Overlay, Tooltip } from "react-bootstrap";

export default class ClipboardCopy extends React.Component {
  constructor(props) {
    super(props);
    this.getTarget = this.getTarget.bind(this);
    this.handleTooltip = this.handleTooltip.bind(this);
    this.handleCloseTooltip = this.handleCloseTooltip.bind(this);
    this.state = {
      show: false
    };
  }

  getTarget() {
    return this.target;
  }

  handleTooltip() {
    if (this.props.handleClick) {
      this.props.handleClick();
    }

    this.setState({ show: true });
  }

  handleCloseTooltip() {
    setTimeout(() => {
      this.setState({ show: false });
    }, 900);
  }

  render() {
    const { name, type, iconFontSize } = this.props;

    if (!name) return null;

    return (
      <Clipboard
        data-clipboard-text={name}
        button-title={`Copy ${type} to Clipboard`}
        style={{ background: "none", border: "none" }}
        onClick={this.handleTooltip}
      >
        <i
          className="fa fa-clipboard fa-xs"
          style={{ fontSize: iconFontSize }}
          ref={button => {
            this.target = button;
          }}
        />
        <Overlay
          target={this.getTarget}
          show={this.state.show}
          placement="top"
          onEntered={this.handleCloseTooltip}
        >
          <Tooltip>Copied!</Tooltip>
        </Overlay>
      </Clipboard>
    );
  }
}

ClipboardCopy.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  iconFontSize: PropTypes.string,
  handleClick: PropTypes.func
};

ClipboardCopy.defaultProps = {
  iconFontSize: ".75em"
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/ClipboardCopy/ClipboardCopy.jsx